module.exports = __webpack_public_path__ + "Roboto-Regular-webfont.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Regular-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Regular-webfont.eot
// module chunks = 2